/* Compare catalogue facts only. No cart, checkout, inventory or price mutations. */
(() => {
  const root = document.getElementById('swc-comparison');
  if (!root || root.dataset.ready) return;
  const dialog = root.querySelector('dialog');
  if (typeof dialog.showModal !== 'function') return;
  root.dataset.ready = 'true';
  const ar = root.dataset.locale.startsWith('ar');
  const words = ar ? {
    compare: 'قارن', selected: 'تم الاختيار', limit: 'يمكنك مقارنة ٣ منتجات. أزل منتجاً لإضافة آخر.',
    count: n => `${n} من ٣ منتجات · اختر اثنين على الأقل`, remove: 'إزالة',
    price: 'السعر', availability: 'التوفر', available: 'متوفر', unavailable: 'غير متوفر',
    view: 'عرض المنتج', detail: 'التفاصيل', cleared: 'تم مسح المقارنة'
  } : {
    compare: 'Compare', selected: 'Selected', limit: 'Compare up to 3 products. Remove one to add another.',
    count: n => `${n} of 3 selected · choose at least 2`, remove: 'Remove',
    price: 'Price', availability: 'Availability', available: 'Available', unavailable: 'Sold out',
    view: 'View product', detail: 'Details', cleared: 'Comparison cleared'
  };
  const labels = {'BRAND':'العلامة','MODEL':'الموديل','SCREEN SIZE':'حجم الشاشة','DISPLAY TYPE':'نوع العرض','PANEL TYPE':'نوع اللوحة','RESOLUTION':'الدقة','BACKLIGHT':'الإضاءة الخلفية','COOLING CAPACITY':'قدرة التبريد','COMPRESSOR TYPE':'نوع الضاغط','MODE':'الوضع','CAPACITY':'السعة','WASHING CAPACITY':'سعة الغسيل','DRYING CAPACITY':'سعة التجفيف','COLOUR':'اللون','MATERIAL':'المادة','WEIGHT':'الوزن','CHANNELS':'القنوات'};
  const selected = new Map();
  const tray = root.querySelector('.swc-tray');
  const open = root.querySelector('.swc-open');
  const status = root.querySelector('[role=status]');
  let returnFocus;
  function focusCollection(preferred) {
    const target = preferred || document.querySelector('[data-swc-product]') || document.querySelector('.swc-heading');
    if (!target) return;
    if (target.matches('.swc-heading')) target.tabIndex = -1;
    target.focus();
  }
  function element(tag, text, className) {
    const node = document.createElement(tag);
    if (text !== undefined) node.textContent = text;
    if (className) node.className = className;
    return node;
  }
  function read(button) {
    try {
      const product = JSON.parse(button.dataset.swcProduct);
      return product.id && product.title && product.url?.startsWith('/') ? product : null;
    } catch { return null; }
  }
  function syncButtons(scope = document) {
    scope.querySelectorAll('[data-swc-product]').forEach(button => {
      const product = read(button);
      if (!product) return;
      button.hidden = false;
      const active = selected.has(product.id);
      button.setAttribute('aria-pressed', String(active));
      button.textContent = `${active ? '✓' : '＋'} ${active ? words.selected : words.compare}`;
      button.setAttribute('aria-label', `${active ? words.remove : words.compare}: ${product.title}`);
    });
  }
  function update(message) {
    root.querySelector('.swc-feedback').hidden = true;
    tray.hidden = selected.size === 0;
    document.body.classList.toggle('swc-has-selection', selected.size > 0);
    root.querySelector('[data-swc-count]').textContent = words.count(selected.size);
    open.disabled = selected.size < 2;
    const items = root.querySelector('.swc-tray-items');
    items.replaceChildren();
    selected.forEach(product => {
      const button = element('button', undefined, 'swc-remove');
      button.type = 'button';
      button.setAttribute('aria-label', `${words.remove}: ${product.title}`);
      button.title = `${words.remove}: ${product.title}`;
      if (product.image) {
        const img = element('img'); img.src = product.image; img.alt = ''; img.width = 44; img.height = 44;
        button.append(img);
      } else button.append(element('span', product.title.slice(0, 15)));
      button.append(element('span', '×'));
      button.addEventListener('click', () => {
        selected.delete(product.id); update(words.count(selected.size));
        const cardButton = [...document.querySelectorAll('[data-swc-product]')].find(node => read(node)?.id === product.id);
        const focusTarget = selected.size ? root.querySelector('.swc-remove') : cardButton || document.querySelector('[data-swc-product]');
        focusCollection(focusTarget);
      });
      items.append(button);
    });
    syncButtons();
    if (message) status.textContent = message;
  }
  function row(table, title, values) {
    const tr = element('tr');
    const label = element('th', title); label.scope = 'row'; tr.append(label);
    values.forEach(value => tr.append(element('td', value || (ar ? 'غير مذكور' : 'Not specified'))));
    table.append(tr);
  }
  function renderComparison() {
    const products = [...selected.values()];
    const table = element('table');
    table.className = 'swc-count-' + products.length;
    const caption = element('caption', ar ? 'مقارنة المنتجات المختارة' : 'Selected product comparison');
    table.append(caption);
    const head = element('thead'); const headRow = element('tr');
    const detail = element('th', words.detail); detail.scope = 'col'; headRow.append(detail);
    products.forEach(product => {
      const cell = element('th'); cell.scope = 'col';
      if (product.image) {const img = element('img'); img.src = product.image; img.alt = ''; img.width = 160; img.height = 130; cell.append(img);}
      cell.append(element('h3', product.title));
      const link = element('a', `${words.view} ↗`); link.href = product.url; cell.append(link); headRow.append(cell);
    });
    head.append(headRow); table.append(head);
    const body = element('tbody');
    row(body, words.price, products.map(p => p.price));
    row(body, words.availability, products.map(p => p.available ? words.available : words.unavailable));
    const maps = products.map(product => {
      const map = new Map();
      (product.specs || []).forEach(([key, value]) => {
        if (!Object.hasOwn(labels, key)) return;
        const values = map.get(key) || [];
        if (!values.includes(value)) values.push(value);
        map.set(key, values);
      });
      return map;
    });
    Object.keys(labels).forEach(key => {
      if (!maps.some(map => map.has(key))) return;
      row(body, ar ? labels[key] : key.toLowerCase().replace(/^./, c => c.toUpperCase()), maps.map(map => (map.get(key) || []).join(', ')));
    });
    table.append(body);
    root.querySelector('.swc-table-scroll').replaceChildren(table);
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-swc-product]');
    if (!button) return;
    const product = read(button); if (!product) return;
    if (selected.has(product.id)) selected.delete(product.id);
    else if (selected.size < 3) selected.set(product.id, product);
    else {
      status.textContent = words.limit;
      const feedback = root.querySelector('.swc-feedback'); feedback.textContent = words.limit; feedback.hidden = false;
      return;
    }
    update(words.count(selected.size));
  });
  open.addEventListener('click', () => {
    if (selected.size < 2) return;
    returnFocus = document.activeElement;
    renderComparison(); dialog.showModal();
    document.dispatchEvent(new CustomEvent('switchon:comparison-opened', {detail: {productIds: [...selected.keys()]}}));
    root.querySelector('.swc-close').focus();
  });
  root.querySelector('.swc-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {if (returnFocus?.isConnected) returnFocus.focus();});
  root.querySelector('.swc-clear').addEventListener('click', () => {
    selected.clear(); update(words.cleared); focusCollection();
  });
  syncButtons();
  // Native filters and pagination replace/add cards without a full navigation.
  const collection = document.querySelector('.collection-wrapper')?.closest('.shopify-section');
  if (collection) new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node.nodeType === 1) {
        if (node.matches('[data-swc-product]')) syncButtons(node.parentElement);
        else if (node.querySelector('[data-swc-product]')) syncButtons(node);
      }
    }
  }).observe(collection, {childList:true, subtree:true});
})();
